import { AclResourceType } from './acl-resource-type.model';

// All api roles
export enum AclRole {
  Administrator = 'administrator',
  BillingAdministrator = 'billing_administrator',
  Owner = 'owner',
  Manager = 'manager', // Same as Owner but for teams and api keys
  Creator = 'creator',
  Editor = 'editor',
  Member = 'member',
  Viewer = 'viewer',
  Guest = 'guest',
}

export interface AclRoleWithTooltip {
  role: AclRole;
  tooltip: string;
}

export interface AclSelectRolesContext {
  allRoles: AclRole[];
  grantedRoles: AclRoleWithTooltip[];
  inheritedRole?: AclRole;
  directRole?: AclRole;
  spaceId?: string;
  resourceType?: AclResourceType;
}

export interface AclRoleHttpModel {
  name: AclRole;
}
